import { Component, Input } from '@angular/core';
import { Feedback, FeedbackItem, FeedbackStatus } from '../../../model/common.model';
import { TableModule } from 'primeng/table';
import { CommonModule } from '@angular/common';
import { CoreModule } from '../../../core/core.module';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { FeedbackService } from '../../../services/feedback.service';
import { OrderService } from '../../../services/order.service';
import { SubmitOrderFeedbackComponent } from '../submit-order-feedback/submit-order-feedback.component';
import { Order } from '../../../model/menu-data.model';

@Component({
  selector: 'brt-manage-feedback',
  standalone: true,
  imports: [CommonModule, CoreModule, TableModule, ButtonModule, DialogModule, SubmitOrderFeedbackComponent],
  templateUrl: './manage-feedback.component.html',
  styleUrl: './manage-feedback.component.css'
})
export class ManageFeedbackComponent {
  @Input({ required: true }) feedbacks!: Feedback[];
  @Input() loading = false;
  @Input() limit = 50;
  @Input() total = 0;

  showFeedbackForm = false;
  selectedFeedback?: Feedback;
  items?: FeedbackItem[];
  order?: Order;

  constructor(private feedbackService: FeedbackService, private orderService: OrderService) { }

  async setStatus(feedback: Feedback, status: FeedbackStatus) {
    this.loading = true;
    feedback = await this.feedbackService.setStatus(feedback.Id, status);
    this.feedbacks[(this.feedbacks.findIndex(f => f.Id === feedback.Id))] = feedback;
    this.loading = false;
  }

  async showFeedback(feedback: Feedback) {
    this.selectedFeedback = feedback;
    switch (feedback.ItemType) {
      case 'Order':
        this.loading = true;
        delete this.order;
        this.order = await this.orderService.getOrder(feedback.Items!.find(i => i.Type === 'Order')!.ItemId);
        this.loading = false;
        break;
    }
    this.showFeedbackForm = true;
  }

  
}
